import { Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';

import RMFAddress from '../components/RMFAddress/RMFAddress';
import RMFBankDetails from '../components/RMFBankDetails/RMFBankDetails';
import RMFGender from '../components/RMFGender/RMFGender';
import RMFIdentityVerification from '../components/RMFIdentityVerification/RMFIdentityVerification';
import RMFLegalName from '../components/RMFLegalName/RMFLegalName';
import RMFTermsOfService from '../components/RMFTermsOfService/RMFTermsOfService';

import useRMFBaseSteps from './useRMFBaseSteps';
import { Service } from './useRmfServices';

const useRmfPTFlow = (): FlowConfig => {
  const { jumpToFeatureStep, forkJumpToFeature, forkRmfExit, invokeSignupDob, forkDobCheck } =
    useRMFBaseSteps();

  const invokeEnableRealMoneyFlag = new Invoke(
    Service.RmfEnableRealMoneyFlag,
    forkJumpToFeature,
    RMFTermsOfService
  );

  const invokeUpdateBankDetails = new Invoke(
    Service.RmfUpdateBankDetailsInfo,
    invokeEnableRealMoneyFlag,
    RMFTermsOfService
  );

  const invokeLegalNameSave = new Invoke(Service.RmfLegalNameSave, RMFGender, RMFLegalName);
  const invokeGetBankDetails = new Invoke(Service.RmfGetBankDetailsInfo, RMFBankDetails);
  const invokeGenderSave = new Invoke(Service.RmfGenderSave, RMFAddress, RMFGender);
  const invokeAddressSave = new Invoke(Service.RmfAddressSave, RMFIdentityVerification, RMFAddress);

  const invokeIdentityVerificationSave = new Invoke(
    Service.RmfIdentifyVerificationSavePT,
    invokeGetBankDetails,
    RMFIdentityVerification
  );

  return [
    invokeSignupDob,
    forkDobCheck,
    invokeLegalNameSave,
    RMFGender,
    invokeGenderSave,
    RMFAddress,
    invokeAddressSave,
    RMFIdentityVerification,
    invokeIdentityVerificationSave,
    invokeGetBankDetails,
    RMFBankDetails,
    RMFTermsOfService,
    invokeUpdateBankDetails,
    invokeEnableRealMoneyFlag,
    forkRmfExit,
    jumpToFeatureStep
  ];
};

export default useRmfPTFlow;
